import storage from 'redux-persist/lib/storage'
import { persistReducer } from 'redux-persist'
import {
  GlobalFeatureNameSpaceNotary,
  CommonActionSubTypeNotary
} from './globalNotary'

const reduxLocalStorageConfig = key => {
  return { key, storage }
}

export {
  reduxLocalStorageConfig,
  persistReducer,
  GlobalFeatureNameSpaceNotary,
  CommonActionSubTypeNotary
}
